import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { DateTime, Zone } from 'luxon';
import { GeneralService } from '../../../../services/general/general.service';
import { HoursPackDialogComponent } from 'src/app/components/hours-pack/hours-pack-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../shared-styles/wallet.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {
  public isMobile: any;
  public headerHeight: any = 0;
  public paginate: any = 0;
  public loading: any = false;
  public loading2 = false;
  // public subscriptions: any = [];
  public dataSource: any;
  // public displayedColumns: string[] = [
  //   'photo_url',
  //   'quantity',
  //   'teacher_id',
  //   'teacher_name',
    
  // ];
  // public isTeacher = true;
  public walletLength: any = 0;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private dialog: MatDialog
  ) {
    this.isMobile = this.general.isMobile();
  
  }

  async ngOnInit() {
    try {
      this.general.setLoading(true);
      await this.getWallet();
    } catch (error) {
        console.log(error);
        
    } finally {
      this.general.setLoading(false);
    }
  }

  navigateTeacher(teacher:any, lesson_id:any, name:any) {
      // console.log(teacher, lesson_id);   
     
    const params = {
      subject: lesson_id,
      id: lesson_id,
      name: name

    };
    localStorage.setItem('current-teacher-result', JSON.stringify(params));
    this.general.openNewTab(`/search/teacher/${teacher}/${lesson_id}`);
      
  }


  async getWallet() {
    const response = await this.general.httpGet('wallet-mine', {
      page: this.paginate + 1,
    });
    this.dataSource = response.data;
    // console.log("dataSource", this.dataSource);    
    this.walletLength = this.dataSource.find((e: { teacher_name: string; }) => e.teacher_name=="free");
    if (this.walletLength==null) {this.walletLength=0;}
   // console.log("walletLength", this.walletLength);
    
  }
}
